var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 39,
    viewBox: "0 0 33 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3286_1631",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 0H0V39H33V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3286_1631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.57 29.4648L20.3744 36.5747C18.7391 38.8125 15.3993 38.8125 13.764 36.5747L8.56836 29.4648H25.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7188 32.7052C25.474 32.7052 32.5714 25.6077 32.5714 16.8526C32.5714 8.09745 25.474 1 16.7188 1C7.96366 1 0.866211 8.09745 0.866211 16.8526C0.866211 25.6077 7.96366 32.7052 16.7188 32.7052Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6544 9.00374C19.3652 9.00374 21.0238 9.00054 22.6817 9.00615C23.0757 9.00775 23.4769 8.99572 23.8629 9.06227C24.9422 9.24748 25.7711 10.1342 25.8585 11.219C25.9075 11.8284 25.8674 12.4449 25.8674 13.0679C25.6772 13.1064 25.4942 13.1336 25.3169 13.1818C24.1694 13.492 23.3782 14.5071 23.3638 15.6969C23.3589 16.0689 23.3397 16.4498 23.4055 16.813C23.6141 17.9707 24.5104 18.7933 25.6876 18.9577C25.7406 18.9649 25.7927 18.9777 25.8505 18.9889C25.8505 19.6584 25.9219 20.3223 25.8353 20.9653C25.6643 22.2345 24.6436 23.0547 23.3236 23.0627C21.7525 23.0715 20.1821 23.0651 18.6109 23.0651C18.306 23.0651 18.0003 23.0651 17.6753 23.0651C17.6753 21.5963 17.6753 20.1635 17.6753 18.7131C17.7732 18.6819 17.8751 18.6482 17.9778 18.6161C19.0916 18.2633 19.8643 17.2275 19.8756 16.0729C19.8876 14.8887 19.1486 13.832 18.0147 13.48C17.7106 13.3854 17.644 13.2467 17.648 12.9532C17.6648 11.7682 17.6552 10.5824 17.6552 9.39741C17.6544 9.27875 17.6544 9.16009 17.6544 9.00374Z",
    fill: "#FFAE4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.987C9.8225 18.906 10.4725 18.5797 10.9587 17.9591C11.3142 17.5053 11.5132 16.989 11.514 16.4093C11.514 16.026 11.5381 15.6348 11.4723 15.2611C11.2757 14.1499 10.442 13.3465 9.32258 13.1333C9.22548 13.1148 9.12839 13.0956 9.05537 13.0819C9.05537 12.3772 8.97673 11.6676 9.07382 10.9829C9.22548 9.90614 10.1635 9.05707 11.2532 9.0266C13.0403 8.97609 14.8305 9.01297 16.6448 9.01297C16.6536 9.118 16.6681 9.21181 16.6681 9.30562C16.6697 10.5564 16.6657 11.8079 16.6729 13.0587C16.6745 13.2696 16.6376 13.3794 16.4009 13.4491C15.2213 13.7987 14.4606 14.8402 14.4654 16.0533C14.4702 17.2471 15.2349 18.2654 16.4009 18.6286C16.4835 18.6542 16.5646 18.6815 16.6545 18.7103C16.6545 20.1567 16.6545 21.5911 16.6545 23.0671C16.5325 23.0671 16.4266 23.0671 16.3198 23.0671C14.7599 23.0671 13.2008 23.0704 11.6408 23.0663C10.0343 23.0615 9.0016 22.0273 9 20.4301C9 19.9595 9 19.4889 9 18.987Z",
    fill: "#FFAE4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02332 14.1052C9.81853 14.1725 10.4541 14.7803 10.5142 15.5387C10.5399 15.8658 10.5399 16.1978 10.515 16.5249C10.4581 17.285 9.78242 17.932 9.02332 17.9561C9.02332 16.6804 9.02332 15.4048 9.02332 14.1052Z",
    fill: "#FFCA8D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8648 14.093C25.8648 15.3918 25.8648 16.6699 25.8648 17.9479C25.1322 17.9663 24.4189 17.2952 24.3619 16.5223C24.3378 16.196 24.337 15.8641 24.3627 15.5378C24.4213 14.7873 25.0215 14.2092 25.8648 14.093Z",
    fill: "#FFCA8D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6554 17.6309C17.6554 17.517 17.6554 17.4296 17.6554 17.343C17.6554 16.3777 17.6554 15.4132 17.6554 14.4462C18.2805 14.5032 18.8558 15.2151 18.8871 15.952C18.9208 16.7457 18.3808 17.5074 17.6554 17.6309Z",
    fill: "#FFAE4F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6468 14.4329C16.6468 15.5008 16.6468 16.5664 16.6468 17.6367C15.9567 17.4804 15.4544 16.8021 15.4528 16.046C15.4504 15.2731 15.9463 14.598 16.6468 14.4329Z",
    fill: "#FFAE4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampMapIcon);
export default __webpack_public_path__ + "static/media/campMapIcon.5ecad4345d630b5652b3bb0e2ed937fd.svg";
export { ForwardRef as ReactComponent };